import script from "./AdminAssignment.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAssignment.vue?vue&type=script&setup=true&lang=js"

import "./AdminAssignment.vue?vue&type=style&index=0&id=9889d7ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9889d7ea"]])

export default __exports__